<template>
  <el-dialog
    :visible="!!editingContentProject"
    :title="disalbed ? '查看内容' : '编辑内容'"
    width="1000px"
    @close="closeDialog"
  >
    <el-form
      v-if="detail"
      :model="detail"
      ref="form"
      :rules="rules"
      label-width="140px"
    >
      <el-form-item label="语言:">
        <el-select v-model="type" placeholder="请选择">
          <el-option
            v-for="item in languageList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="名称：" prop="name">
        <el-input v-model="detail.name"></el-input>
      </el-form-item>

      <el-form-item label="介绍图片：" prop="infoImageUrl">
        <upload
          v-model="detail.infoImageUrl"
          :data="{ category: 'purchase' }"
        ></upload>
      </el-form-item>

      <el-form-item label="规则介绍：" prop="ruleText">
        <editor v-model="detail.ruleText" class="editor"></editor>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button v-if="!disalbed" type="primary" @click="handleSave()"
        >保存</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import Editor from 'components/editor';
import Upload from 'components/upload';
import LANGUAGE from 'common/languages';
import MutipleInput from '../mutipleInput';

export default {
  name: 'purchaseProjectDetail',
  data() {
    return {
      type: '1',
      detail: {
        ruleText: ''
      },
      rules: {
        infoImageUrl: {
          required: true,
          message: '请填写'
        },
        name: {
          required: true,
          message: '请填写'
        }
      }
    };
  },
  computed: {
    ...mapState('discount', ['editingContentProject', 'languageList']),
    disalbed() {
      return false;
      // return this.detail && this.detail.status !== 0;
    }
  },
  watch: {
    editingContentProject(val) {
      this.getData();
    },
    type(val, oldVal) {
      if (val != oldVal) {
        this.getData();
      }
    }
  },
  components: {
    Editor,
    Upload,
    MutipleInput
  },
  methods: {
    ...mapMutations('discount', ['setEditingContentProject']),
    ...mapActions('discount', ['getPurchaseLanguageContent', 'updateContent']),
    closeDialog() {
      this.$refs['form'].resetFields();
      this.setEditingContentProject(null);
    },
    getData() {
      this.detail = null;
      if (!this.editingContentProject) return;
      this.getPurchaseLanguageContent({
        type: this.type,
        purchaseId: this.editingContentProject.id
      }).then(({ data }) => {
        this.detail = data;
      });
    },
    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.doSave();
        }
      });
    },
    doSave() {
      if (!this.editingContentProject) return;
      this.updateContent({
        ...this.detail,
        purchaseId: this.editingContentProject.id,
        type: this.type
      }).then(() => {
        this.$message({
          message: '修改成功！',
          type: 'success'
        });
        this.closeDialog();
        this.$emit('refresh', {
          page: 1
        });
      });
    }
  },
  mounted() {
    this.getData();
  }
};
</script>
<style lang="less" scoped>
.editor {
  height: 450px;
}
</style>
